"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable-next-line:export-name no-require-imports no-var-requires
exports.Languages = require("./languages.json");
//# sourceMappingURL=languages.js.map